let currentVersion = process.env.REACT_APP_SOURCE_VERSION;
export function setLatestClientVersion(version: string) {
  currentVersion = version;
}

let firstLoadEnvHash = "";
let currentEnvHash = "";
export function setLatestEnvHash(hash: string) {
  if (!firstLoadEnvHash) {
    firstLoadEnvHash = hash;
  }
  currentEnvHash = hash;
}

export function shouldRefreshOnNavigation(): boolean {
  return (
    !!(
      currentVersion &&
      process.env.REACT_APP_SOURCE_VERSION &&
      currentVersion !== process.env.REACT_APP_SOURCE_VERSION
    ) ||
    !!(
      firstLoadEnvHash &&
      currentEnvHash &&
      firstLoadEnvHash !== currentEnvHash
    )
  );
}
